// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DateSelector.css */

.date-selector-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .date-selector-container p {
    font-weight: 600;
    color: #333;
  }
  
  /* Arrows + scroll group */
  .date-slider-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
  }
  
  /* Scroll area */
  .date-scroll {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding: 8px 0;
    scroll-behavior: smooth;
    flex: 1 1;
  }
  
  /* Hide scrollbars */
  .date-scroll::-webkit-scrollbar {
    display: none;
  }
  .date-scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  /* Center if no overflow */
  .date-scroll.centered {
    justify-content: center;
    overflow-x: hidden;
  }
  
  /* Each date box */
  .date-block {
    flex: 0 0 auto;
    min-width: 110px;
    padding: 10px 16px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .date-block:hover {
    background-color: #f3f6fa;
    border-color: var(--clr-primary-3);
  }
  
  .date-block.selected {
    background-color: var(--clr-primary-3);
    color: #fff;
    font-weight: bold;
    border-color: var(--clr-primary-3);
  }
  
  /* Arrow buttons */
  .scroll-btn {
    background-color: #eee;
    border: none;
    border-radius: 50%;
    font-size: 1.2rem;
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .scroll-btn:hover {
    background-color: #ddd;
  }
  
  /* Responsive tweaks */
  @media (max-width: 480px) {
    .date-block {
      min-width: 90px;
      font-size: 0.85rem;
      padding: 8px 10px;
    }
  
    .scroll-btn {
      width: 28px;
      height: 28px;
      font-size: 1rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/DateSelector.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;EACpB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,SAAO;EACT;;EAEA,oBAAoB;EACpB;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA,0BAA0B;EAC1B;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,sCAAsC;IACtC,WAAW;IACX,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA,kBAAkB;EAClB;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;MACf,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF","sourcesContent":["/* DateSelector.css */\n\n.date-selector-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .date-selector-container p {\n    font-weight: 600;\n    color: #333;\n  }\n  \n  /* Arrows + scroll group */\n  .date-slider-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n  }\n  \n  /* Scroll area */\n  .date-scroll {\n    display: flex;\n    overflow-x: auto;\n    gap: 10px;\n    padding: 8px 0;\n    scroll-behavior: smooth;\n    flex: 1;\n  }\n  \n  /* Hide scrollbars */\n  .date-scroll::-webkit-scrollbar {\n    display: none;\n  }\n  .date-scroll {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  \n  /* Center if no overflow */\n  .date-scroll.centered {\n    justify-content: center;\n    overflow-x: hidden;\n  }\n  \n  /* Each date box */\n  .date-block {\n    flex: 0 0 auto;\n    min-width: 110px;\n    padding: 10px 16px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    background-color: #fff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: center;\n    user-select: none;\n  }\n  \n  .date-block:hover {\n    background-color: #f3f6fa;\n    border-color: var(--clr-primary-3);\n  }\n  \n  .date-block.selected {\n    background-color: var(--clr-primary-3);\n    color: #fff;\n    font-weight: bold;\n    border-color: var(--clr-primary-3);\n  }\n  \n  /* Arrow buttons */\n  .scroll-btn {\n    background-color: #eee;\n    border: none;\n    border-radius: 50%;\n    font-size: 1.2rem;\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .scroll-btn:hover {\n    background-color: #ddd;\n  }\n  \n  /* Responsive tweaks */\n  @media (max-width: 480px) {\n    .date-block {\n      min-width: 90px;\n      font-size: 0.85rem;\n      padding: 8px 10px;\n    }\n  \n    .scroll-btn {\n      width: 28px;\n      height: 28px;\n      font-size: 1rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
